import Header from '../components/Header';
import Sidemenu from '../components/Sidemenu';
import BookingForm from '../components/BookingForm';
import Slider from '../components/Slider';
import ImgModal from '../components/ImgModal';
//import CookiesBar from '../components/CookiesBar';
import Toggleable from '../components/Toggleable';
import Swipeable from '../components/Swipeable';
import PopupInfo from '../components/PopupInfo';
import Youtube from '../components/Youtube';

export default {
  init() {
    // JavaScript to be fired on all pages
    new Header();
    new Sidemenu();
    //new CookiesBar('.cookies-bar', '.cookies-bar__accept');

    // Booking Form
    $('.blocks__booking-form__form').each((key, form) => {
      new BookingForm($(form));
    });

    // Slider
    $('.blocks__slider__item').each((key, slider) => {
      new Slider($(slider));
    });

    // Slider ImgModal
    $('.blocks__slider__item > ul > li > img').each((key, img) => {
      new ImgModal(img);
    });

    // Swipeable
    $('.blocks__extra-info__list').each((key, object) => {
      if (
        $(object)
          .parent()
          .hasClass('is-style-vertical')
      ) {
        return;
      }

      new Swipeable(
        object,
        null,
        $(object)
          .parent()
          .find(
            '.blocks__extra-info__list__button__left,.blocks__extra-info__list__button__right'
          )
      );
    });

    // Collapsable Menu
    $('.menu-item-has-children').each((key, menu) => {
      new Toggleable($(menu).find('> a'), $(menu).find('> .sub-menu'));
    });

    $('.footer__main .widget').each((key, widget) => {
      new Toggleable($(widget).find('> h3'), $(widget).find('> h3 + *'));
    });

    $('.blocks__extra-info .toggleable__extra-info').each((key, extra_info) => {
      new Toggleable(
        extra_info,
        $(extra_info).data('target'),
        $(extra_info).data('scope'),
        true
      );
    });

    // PopupInfo
    $('.floating-widgets .popup-info').each((key, popup) => {
      new PopupInfo($(popup).find('.close-icon'), popup);
    });

    $('.wp-block-embed-youtube iframe').each((key, iframe) => {
      new Youtube(iframe);
    });

    // Location resize
    $(window).load(this.locationsResize.bind(this));
    $(window).resize(this.locationsResize.bind(this));
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },

  locationsResize() {
    $('.blocks__apartment__list .blocks__apartment__item__excerpt').css(
      'min-height',
      0
    );

    if ($(window).width() <= 768) return;

    $('.blocks__apartment__list').each((key, list) => {
      let max_height = 0,
        $excerpts = $(list).find('.blocks__apartment__item__excerpt');

      $excerpts
        .each((key, excerpt) => {
          if ($(excerpt).height() > max_height) {
            max_height = $(excerpt).height();
          }
        })
        .css('min-height', max_height);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js